import { Configuration } from 'pages/ValuationsAllocation/hooks';
import { getNumberValue } from 'utilities';

const sortApproaches = (a: Configuration, b: Configuration) =>
  getNumberValue(a?.approach?.id ?? Infinity) - getNumberValue(b?.approach?.id ?? Infinity);

export default sortApproaches;
